/**
 * RailNav - port 1:1 z new-design/layout.jsx.
 *
 * Icon rail po lewej (240px width z legacy.css). Sections z NAV array.
 * Active state z route section detection.
 */
import { useNavigate } from "react-router-dom";
import { Icon } from "@/components/ui/Icon";
import { BrandMark } from "@/components/ui/BrandMark";
import { NAV } from "@/lib/data";
import { usePlan } from "@/hooks/usePlan";
import { creditsTitle, formatCredits } from "@/lib/credits";

interface RailNavProps {
  sectionId: string;
  onSection: (id: string) => void;
  /** `null` = saldo jeszcze nie dojechało z API (patrz lib/credits). */
  credits: number | null;
  onBuy: () => void;
  /** Czy licznik kredytów prowadzi do doładowania (patrz useCreditPurchase). */
  canBuy?: boolean;
  userInitials?: string;
  userName?: string;
  isAdmin?: boolean;
}

export function RailNav({
  sectionId,
  onSection,
  credits,
  onBuy,
  canBuy = true,
  userInitials = "MK",
  userName = "Marek Kowalski",
  isAdmin = false,
}: RailNavProps) {
  const navigate = useNavigate();
  const { tier, label: planLabel } = usePlan();
  return (
    <aside className="railnav">
      <div className="railnav__logo">
        <span className="logo-mark">
          <BrandMark size={24} />
        </span>
      </div>
      <div className="railnav__items">
        {/* „admin" ma osobny przycisk w stopce (railnav__foot) — nie dublujemy go
            w głównej liście.  */}
        {NAV.filter((s) => s.id !== "admin").map((s) => {
          const active = s.id === sectionId;
          return (
            <button
              key={s.id}
              className={`rail-item ${active ? "is-active" : ""}`}
              style={{ ["--rail" as string]: s.accent || "var(--accent)" }}
              onClick={() => onSection(s.id)}
            >
              <span className="rail-item__icon">
                <Icon name={s.icon} />
              </span>
              <span className="rail-item__label">{s.label}</span>
            </button>
          );
        })}
      </div>
      <div className="railnav__foot">
        {isAdmin && (
          <button
            className={`rail-item ${sectionId === "admin" ? "is-active" : ""}`}
            onClick={() => navigate("/admin")}
            title="Panel admina"
            style={{ marginBottom: 4 }}
          >
            <span className="rail-item__icon">
              <Icon name="settings" />
            </span>
            <span className="rail-item__label">Admin</span>
          </button>
        )}
        {/* Bez doładowań licznik nie prowadzi nigdzie (patrz useCreditPurchase). */}
        {canBuy ? (
          <button className="rail-coin" onClick={onBuy} title={creditsTitle(credits, true)}>
            <span className="rail-coin__chip">
              <Icon name="coins" />
            </span>
            <span className="rail-coin__num">{formatCredits(credits)}</span>
          </button>
        ) : (
          <span className="rail-coin" title={creditsTitle(credits, false)}>
            <span className="rail-coin__chip">
              <Icon name="coins" />
            </span>
            <span className="rail-coin__num">{formatCredits(credits)}</span>
          </span>
        )}
        <div style={{ position: "relative", display: "inline-flex" }}>
          <div className="avatar" title={`${userName} · ${planLabel}`} onClick={() => onSection("konto")}>
            {userInitials}
          </div>
          {tier !== "free" && (
            <span style={{
              position: "absolute", bottom: -4, right: -6,
              fontSize: 9, fontWeight: 700, letterSpacing: 0.3,
              background: "var(--accent)", color: "white",
              padding: "1px 5px", borderRadius: 4,
              textTransform: "uppercase", lineHeight: 1.6,
              pointerEvents: "none",
            }}>
              {planLabel}
            </span>
          )}
        </div>
      </div>
    </aside>
  );
}
